import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import type { DocumentRecord } from "@shyne/shared/api";
import { DocumentsRepository } from "@/repositories/documents.repository";

export function DocumentOpenLink({ document }: { document: DocumentRecord }) {
  const [opening, setOpening] = useState(false);

  const open = () => {
    setOpening(true);
    DocumentsRepository.open(document.id)
      .catch((error: unknown) => toast.error(error instanceof Error ? error.message : "The document could not be opened."))
      .finally(() => setOpening(false));
  };

  return (
    <button type="button" className="flex items-center gap-2 text-left hover:underline" onClick={open} disabled={opening}>
      {opening ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
      <span className="font-medium">{document.filename}</span>
    </button>
  );
}
